import React from "react";
import { HeroStatsProps, backgroundColors } from "../types";
import sortBySortValue from "@/utils/functions/sortBySortValue";
import Image from "next/image";
import { US_NEWS_LOGO } from "../constants";
import useTranslations from "@/i18n/useTranslations";

const LightLogo = ({
  courseDetails,
  hasUsNewsLogo = true,
  rankingAvailable = true,
  background = "white",
  colorBarHexValue,
}: HeroStatsProps) => {
  const t = useTranslations("Common");
  const courseDetailsLength = courseDetails ? courseDetails.length : 0;
  const backgroundColorClass = backgroundColors[background];
  const bottomBorderClass = colorBarHexValue
    ? `!border-[${colorBarHexValue}] !border-b-[8px]`
    : "";

  const firstColIsTuition =
    courseDetails &&
    courseDetails.length > 0 &&
    typeof courseDetails[0].description === "string" &&
    courseDetails[0]?.description?.includes("Tuition");

  // If its not a rank, don't use the wide column
  const totalCols =
    courseDetailsLength > 4 && hasUsNewsLogo
      ? "md:grid-cols-7"
      : `md:grid-cols-${courseDetailsLength}`;
  return (
    <div className="container">
      <div
        style={{ borderBottomColor: `${colorBarHexValue}` }}
        className={`${backgroundColorClass} ${bottomBorderClass} rounded-xl grid grid-cols-1 ${totalCols} grid-rows-auto gap-2 p-2`}
      >
        {sortBySortValue(courseDetails || []).map((detail, index) => {
          const firstClass =
            index === 0 && courseDetailsLength > 4 && hasUsNewsLogo
              ? "text-left md:text-left w-full md:col-span-3 items-center content-center md:m-2 pb-4 pr-2"
              : "first:pl-4 text-left w-full md:col-span-1 content-start md:m-2";
          const headerClass =
            rankingAvailable &&
            index === 0 &&
            courseDetailsLength > 4 &&
            hasUsNewsLogo
              ? "text-2xl"
              : "";
          const image =
            rankingAvailable && hasUsNewsLogo && index === 0 ? (
              <Image
                src={US_NEWS_LOGO}
                alt={t("usNewsLogoAlt")}
                width={117}
                height={100}
                className="w-[117px] float-left pr-4 border-none py-4"
                unoptimized
              />
            ) : null;
          return (
            <div
              className={`${firstClass} `}
              key={`${detail.heading}-${index}`}
            >
              {image}
              <p className={`${headerClass} my-1 font-black font-bold`}>
                {detail.heading}
              </p>
              <p className="mb-0 text-sm">{detail.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LightLogo;
